export enum BankDetailsStatus {
  /// <summary>
  /// Стандартна сметка
  /// </summary>
  Standard = 0,
  /// <summary>
  /// Бюджетна
  /// </summary>
  Budget = 1,
}
